import { Inject, Injectable, InjectionToken } from '@angular/core';

import { RedirectStrategy } from './redirect-strategy';

export const REDIRECT_STRATEGIES = new InjectionToken<RedirectStrategy>('REDIRECT_STRATEGIES');

@Injectable({
    providedIn: 'root'
})
export class RedirectStrategyFactory {
    private readonly strategies: Record<string, RedirectStrategy> = {};

    constructor(@Inject(REDIRECT_STRATEGIES) availableStrategies: RedirectStrategy[]) {
        availableStrategies.forEach(strategy => {
            this.strategies[strategy.strategyName()] = strategy;
        });
    }

    create(strategy: keyof typeof this.strategies): RedirectStrategy | false {
        if (!this.strategies[strategy]) {
            return false;
        }
        return this.strategies[strategy];
    }
}
